export const AccessProfileEnum = {
  FUNCTIONALITY: {
    AREAS: '1',
    UPDATES: '2',
    COMMITTEE: '3',
    SCHEDULE: '4',
    NOTIFICATIONS: '5',
    ANALYTICS: '6',
    USERS: '7',
    ACCESS_PROFILES: '8',
    REPORTS: '9',
    MANAGE_REGISTRATIONS: '10',
  },
  RULE: {
    SHOW: '1',
    EDIT: '2',
    CREATE: '3',
    DELETE: '4',
  },
} as const
